<template>
  <div class="message-notice">
    <el-badge :is-dot="total > 0 ? true: false">
      <i class="el-icon-message-solid message-icon" @click="click"></i>
    </el-badge>
    <el-drawer
      :visible.sync="drawer"
      size="25%"
      >
      <div class="drawer-warp-msg">  
        <el-tabs v-model="activeMessage" @tab-click="handleClick">
          <el-tab-pane name="1">
            <span slot="label">
              <el-badge :value="total" :max="99" class="m_badge">
                 未读通知
              </el-badge>
            </span>
              <div class="msg-row">
                <ul>
                  <li v-for="(item,index) in list" :key="index" @click="onClickMsg(item)">
                     <div class="row1">
                       {{ item.title }}
                     </div>
                     <div class="row2">
                       <a v-tooltip.bottom="{content:item.content, offset: 10, class: 'tooltip-custom tooltip-other-custom' }">{{ item.content}}</a>
                     </div>
                     <div class="row3">
                        {{ item.createtime == 0 ? '' : M(item.createtime).format('YYYY-MM-DD HH:mm:ss') }}
                     </div>
                     <div class="unread" v-if="item.read_time === 0"></div>
                  </li>
                </ul>
                <empty v-if="list && list.length === 0" class="empty" text="暂无数据~"></empty>
              </div>
          </el-tab-pane>
          <el-tab-pane label="全部通知" name="0">
            <div class="msg-row">
              <ul>
                 <li v-for="(item,index) in list" :key="index" @click="onClickMsg(item)">
                     <div :class="item.read_time === 0 ? 'row1' : 'row1 read_row' ">
                       {{ item.title }}
                     </div>
                     <div class="row2" :class="item.read_time === 0 ? 'row2' : 'row2 read_row' ">
                        <a v-tooltip.bottom="{content:item.content, offset: 10, class: 'tooltip-custom tooltip-other-custom' }">{{ item.content}}</a>
                     </div>
                     <div class="row3">
                        {{ item.createtime == 0 ? '' : M(item.createtime).format('YYYY-MM-DD HH:mm:ss') }}
                     </div>
                     <div class="unread" v-if="item.read_time === 0"></div>
                  </li>
                </ul>
              <empty class="empty" v-if="list && list.length === 0" text="暂无数据~"></empty>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Empty from '@/components/empty'
import {  unreadMsg, msgList, readMsg  } from '@/api/system'
export default {
  name: 'MessageNotice',
  components: {
    Empty
  },
  data() {
    return {
      list:null,
      drawer: false,
      activeMessage:'1',
      tip:false,
      listQuery: {
        page: 1,
        page_size: 20
      },
      total:''
    }
  },
  created() {
    let _this = this
    window.setInterval(() => {
     setTimeout(_this.getUnreadMsg(), 0)
    }, 60000)
   },
  methods: {
    click() {
      this.drawer = true
      this.getMsgList()
    },
    getMsgList() {
      const loading = this.$loading({
          lock: true,
          text: '正在努力加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.6)'
      })
      msgList({
        type:this.activeMessage
      })
      .then(res => {
          console.log(res,'消息通知列表')
           loading.close()
          this.list = res.data.list
      })
    },
    getUnreadMsg() {
      unreadMsg()
        .then(res => {
            if(res.data.total > this.total){
              this.total = res.data.total
              this.tip = true
              this.speckText('您有新消息')
              this.$notify({
                  title: '新消息',
                  message: '您有新的消息待处理',
                  position: 'bottom-right'
              })
            }else if(res.data.total < this.total) {
              this.total = res.data.total === 0 ? '' : res.data.total 
            }
        })
    },
    handleClick() {
      this.getMsgList()
    },
    onClickMsg(row) {
      readMsg({
        message_id:row.id
      })
      .then(res => {
          this.getMsgList()
          if(res.code === 1){
            if(row.send_type === 1) { // 成交跟进记录
                this.$router.push({ 
                  path: '/auction/auction-info',
                  query: {
                    id: row.reference_object_id,
                    type: 2
                  }
                })
                this.drawer = false
            }else if(row.send_type === 2 || row.send_type === 3) { // 客户管理
                if(row.redirect_type === 1) { // 私客
                    let routeData = this.$router.resolve({
                    　　path:'/customer/material/material-info'
                    })
                    this.$ls.set('customerInfo',this.listQuery)
                    this.$ls.set('customerId',row.reference_object_id)
                    window.open(routeData.href, '_blank')
                }else { // 公客
                  let routeData = this.$router.resolve({
                    　path:'/customer/material/public-info'
                  })
                  this.$ls.set('publicInfo',this.listQuery)
                  this.$ls.set('publicId',row.reference_object_id)
                  window.open(routeData.href, '_blank')
                }
            }else if(row.send_type === 4) { // 私客列表
              this.$router.push({
              　　path:'/customer/material/material-list'
              })
            }else if(row.send_type === 5) { // 房源列表
              this.$router.push({
              　　path:'/housing/foreclosure/house-list'
              })
            }
          }
      })
    },
    speckText(str) {
      var url = "http://tts.baidu.com/text2audio?lan=zh&ie=UTF-8&spd=5&text=" + encodeURI(str)
      var n = new Audio(url)
      n.src = url
      if(this.tip){
        n.play()
      }else {
        n.pause()
      }
    },
  }
}
</script>

<style>
  .drawer-warp-msg .el-tabs__item{
    font-size: 15px !important;
  }
  .m_badge .el-badge__content.is-fixed{
      top: 8px;
  }
  .el-drawer__body{
    overflow: auto;
  }
</style>
<style lang="scss" scoped>
 .message-icon{
    display: inline-block;
    cursor: pointer;
    color: #606266;
    width: 20px;
    height: 20px;
    vertical-align: 12px;
    font-size: 20px;
  }
  .message-notice {
    .drawer-warp-msg {
      padding: 0 14px;
      .msg-row {
        overflow: auto;
        ul{
          li{
            padding:10px 12px;
            border-bottom: 1px solid #eee;
            cursor: pointer;
            position: relative;
            line-height: 24px;
            .read_row {
              color: #909399 !important;
            }
            .row1{
              font-size: 16px;
              margin-bottom: 8px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
            .row2{
              font-size: 14px;
              margin-bottom: 6px;
              color: #666;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
            .row3{
              font-size: 12px;
              color: #999;
            }
            &:hover{
              background: #f5f7fa;
            }
            .unread {
              position: absolute;
              top: 17px;
              left: 0;
              width: 6px;
              height: 6px;
              background: #f81d22;
              border-radius: 50%;
            }
          }
        }
        .empty {
          margin-top: 100px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/MessageNotice/index.vue